import * as React from "react";
import { AppStore } from "store/Store";

export function useStore() {
  return React.useContext(AppStore);
}
